module.exports = __webpack_public_path__ + "img/turbo_off.fed5bd31.png";